/**
 *Created by jmmartinez on 29/03/19
 * v 1.1 01/04/2019 Corrección de Default en switch(accion)
 * v 1.2 24/04/2019 Añadido excel y pdf?
 * v 1.3 30/05/2019 Añadida propiedad showBusqueda
 *                  Añadido onElementoSeleccionado como propiedad
 * v 1.4 12/06/2019 Añadido evento onElementoBeforeSave
 * v 1.5 30/08/2019 Cambiados nombres de eventos on
 * v.1.6  09/09/2019 Añadido paginaActual al state para conservarlo al volver de la pestaña de datos.
 *                   Se pasa paginaActual a FormularioGrid en Render
 *                   Creado evento onPageChanged para guardar la página actual cuando cambie en FormularioGrid
 *                   Creado evento onDatosBusquedaChanged para guardar los datos de filtrado cuando cambie en FormularioGrid
 * v.1.7 01/10/2019  Modificado el constructor con  marcaTiempoGrid: props.marcaTiempoGrid ? props.marcaTiempoGrid : Date.now()
 *                   Añadido componentWillReceiveProps para que se modifique el marcaTiempoGrid
 *                   Añadida comprobacion de existencia de newProps.marcaTiempoGrid en componentWillReceiveProps.
 *
 * v.1.75 01/10/2019 Creado botón Volver en el título
 *                   Añadido el render del Nombre del elemento.
 *                   Añadida prop llamadoDesdeOtroFormulario.
 *                   Título se renderiza con condiciones de llamaddoDesdeOtroFormulario y showGrid.
 *                   Añadido propiedad id, para usarla en console.log, en caso de formularios anidados.
 *
 * v.1.8  02/10/2019 Eliminada propiedad showAllAcciones={true} en la llamada a Formulario
 *                  Modificado metodo clonarElemento.
 *
 * v.1.9  10/10/2019 Nueva propiedad empresa con los datos de la empresa para el encabezado
 * v.1.10 15/10/2019 Usamos la nueva propiedad datosBusqueda de FormularioGrid para conservar los campos de busqueda al volver.
 *                   Nuevo evento onDatosGridCargados para recibir los datos desde FormularioGrid cuando se actualicen y guardarlos para enviarlos posteriormente.
 *                   Usamos la nueva propiedad infoDatosInicial de FormularioGrid para conservar los datos al volver y no tener que recargar desde la bdd.
 * v.1.11 24/10/2019 En el evento onSavedDatos ponemos infoDatosInicial: null para provocar una recarga por el cambio del registro en la bdd.
 *                   Añadidos valorBuscador y onValorBuscadorCambiado en la llamada a <FormularioGrid
 *                   Añadido evento onValorBuscadorCambiado para guardar en el estado valorBuscador y poder transmitirlo.
 * v.1.12 31/10/2019 En el evento onDatosGridCargados llamamos a elementoSeleccionado para que se transmita la selección inicial al padre.
 * v.1.13 11/11/2019 En la llamada a FormularioGrid pasamos el parámetro elementoConfig
 * v.1.14 20/11/2019 Añadida propiedad onModificarDatosCargados para modificar los datos una vez recibidos pero antes de ser mostrados en el grid.
 * v.1.15 23/11/2019 Añadida propiedad elemento para pasar un objeto seleccionado.
 *                   En el constructor, si se ha pasado un elemento, activar las condiciones para mostrarlo.
 * v.1.16 02/12/2019 En EliminarElemento invalidamos infoDatosInicial.
 * v.1.17 28/01/2020 Añadido evento onAntesCargarDatos para modificar el filtro que se envía en Load antes de enviarlo.
 * v.1.18 18/02/2020 Cambiado renderTitulo para usar la clase Titulo2 cuando es enTab
 *                   Cambiado en el propTypes de onModificarDatosCargados a onModificarDatosGridCargados.
 * v.1.19 25/02/2020 Eliminado el required de ElementoConfig.
 * v.1.20 02/03/2020 Añadida propiedad onAntesGuardar en la llamada <FormularioGrid>, para modificar los objetos antes de guardarlos en un grid editable.
 *                   Añadido evento onNuevoElemento para crear el elemento nuevo de la nueva fila.
 * v.1.21 04/03/2020 Cambiada la propiedad onModificarDatosCargados por onModificarDatosGridCargados
 * v.1.22 10/02/2020 Añadido dialogoTitulo, dialogoTexto, dialogoTipo y onDialogoCerrado a las props.
 *                   Añadidas las propiedades anteriores a la llamada a FormularioDatos y FormularioDatosMultiTab
 * v.1.23 06/04/2020 Añadida funcion onAntesCargarDatos en prop.
 * v.1.24 07/04/2020 Añadida la prop: showGrid para poder modificar que se muestre el detalle desde un componente padre
 * v.1.25 15/04/2020 Añadida propiedad usuario.
 *                   Paso del usuario a FormularioGrid.
 *
 * v.1.26 28/05/2020 Añadida empresa a PropTypes
 * v.1.27 02/06/2020 Añadida función refrescarDatosGrid para llamar de forma imperativa al ref de FormularioGrid y provocar el refresco de datos.
 * v.1.28 03/06/2020 Asignación de Redux mediante connect.
 *                   En el método onClosedDatos, si hay Página de origen en el estado se vuelve a esa, si no se vuelve al grid.
 * v.1.29 23/06/2020 Añadida propiedad marcaTiempoGrid en PropTypes
 * v.1.30 14/07/2020 En el evento onDatosGridCargados, transmitimos el evento segun la propiedad onDatosCargados.
 * v.1.31 24/07/2020 Añadido evento onDatosModificados.
 *                   Añadida propiedad onDatosModificados en llamada a <FormularioGrid
 * v.1.31 28/07/2020 En el método RenderTitulo, si se trata de la accion ACCION_NUEVO se pone "NUEVO", si no el nombre del elemento
 * v.1.32 30/07/2020 Añadida la propiedad onPermitirAceptar.
 *                   Transmitida la propiedad onPermitirAceptar a <FormularioDatos
 * v.1.33 21/09/2020 Creada la funcion renderTitulo2 para enriquecer la impresion del subtitulo. Se pinta  nombre y si no existe, el codigoid.
 * v.2.0  01/10/2020 Cambiado a framework2
 * v.2.1  15/10/2020 Corregido el método renderTítulo para que cuando llamadoDesdeOtroFormulario se use el título calculado.
 *                   Cambiado el margin de 4 a 8 en el div principal
 * v.2.2 19/10/2020  Añadido metodo onFiltroBusquedaChanged para responder al evento onFiltroBusquedaChanged de FormularioGrid.
 * v.2.3 12/11/2020  Añadida propiedad onCalcularSubtitulo y su llamada en render.
 * v.2.4 13/11/2020  En el método renderTitulo2, añadido el codigoid
 *
 *
 * v.2.5 20/11/2020  En el método renderTitulo, corregido para que al volver a la lista desde modificar, no se muestre la acción.
 *                   Añadida propiedad modoMostrarDatos, que se transmite a <FormularioGrid
 *                   En el constructor, aislamos en state.childTablaFlex el child que renderiza la celda de TablaFlezPaginada.
 *                   En la llamada a FormularioGrid pasamos childTablaFlex
 *                   En OnClosedDatos, se ha modificado el setState con marcaTiempoGrid: Date.now() y infoDatosInicial: null. Así provocamos una carga.
 *
 * v.2.6 01/12/2020  En eliminarElemento, al crear la url, pasamos en el path, usuario.codigo
 * v.2.5 03/12/2020  Añadida propiedad usarTituloConDrawer para usar el componente <Titulo
 * v.2.7 12/12/2020  Añadido método onDobleClickCelda
 * v.2.8 04/01/2020  En renderTitulo2, añadida la condicion accion === ACCION_MODIFICAR para mostrarlo. ASi eveitamos que salga en ACCION_NUEVO
 * v.2.7 14/05/2021  En eliminarElemento, a la url DELETE le añadimos el usuarioCodigo= 0 al final.

 * v.2.10 06/07/2021 Creado evento onCalcularAviso, que se llama tras cargar los datos. Creado en el state gridAviso.
                     Añadida propiedad usarFiltros35
 * v.2.11  17/04/2022 Añadida propiedad icon
 *                    Añadido uso de la propiedad icon en los formularios children para insertarlo en el titulo del tab.
 *                    Añadido uso de la propiedad icon en renderTitulo

 * v.2.12  06/05/2022 Unión Sidemur y Planifikator
 * v.2.13  10/10/2022 Modificado onClosedDatos Para tener en cuenta la vuelta a una página con pestañas.
 * v.2.14  26/05/2022 Modificada la propiedad onSavedDatos, añadiendo el parametro accion al llamar al callback.
 * v.2.15  22/06/2022 En eliminarElemento, modificamos el callback de clienteRestful.doDelete para tener en cuenta que el resultado ahora llegará en un objeto.
 * v.2.16  01/07/2022 Añadida propiedad onAntesRenderDatosCampos para modificar los campos de Datos antes de mostrarlos.
 *                    Modificada la llamada a <FormularioDatos para usar la nueva propiedad en onAntesRenderCampos.

 * v.2.17  17/08/2022 Añadida la opción de cargar el elemento de la BDD en vez de la propia lista de elementos.
 *                    Modificado el método elementoSeleccionado para que se cargue de la bdd según el valor de elementoConfig.modoCarga
 * v.2.18  19/10/2022 Corrección en onElementoSeleccionado, para comrpobar que existe elemento. (Para el caso de carga_bf)
 * v.2.19  17/11/2022 Añadida propiedad childrenFormulariogrid.
 *                    Modificado en el render, las llamadas a FormularioGrid para pasar el parámetro childrenFormulariogrid.
 * v.2.20  01/02/2023 En onClosedDatos, modificado this.props.dispatch(estadoChangePagina para añadir los parametros.
 * v.2.21  07/02/2023 En Render, en la llamada a <FormularioGrid, añadimos onDespuesGuardarElemento={onElementoAfterSave}
 *                    Añadida propiedad onClickBotonSubtitulo.
 *                    Modificado renderTitulo2 para renderizar el boton del ojo si hay propiedad onClickBotonSubtitulo
 * v.2.22  13/02/2023 En onSavedDatos, al final comprobamos si hay página de vuelta y la aplicamos.
 * v.2.23  23/02/2023 En elementoSeleccionado, añadimos a la comparación  elementoConfig, por si llega como null: if (elementoConfig && elementoConfig.modoCarga && elementoConfig.modoCarga == ELEMENTO_MODOCARGA_BDD)
 * v.2.24  24/03/2023 En OnClosedDatos, la nueva condición de llamada es  if (!llamadoDesdeOtroFormulario && paginaOrigen)
 * v.2.25  25/03/2023 En el evento onAccion, esperamos el parámetro "elemento" para usarlo en:
 *                    Nuevo evento eliminarDesdeGrid. El eliminar de la botonera no vale por los eventos que se disparan:
 *                          Se lanza antes que el evento elementoSeleccionado y entonces no apunta al elemento correcto.
 *                          Por eso necesitamos el elemento como parámentro para hacer un setStatus previo del elemento.
 * v.2.26  27/04/2023 Añadido método cambiarTabDatos para poder cambiar el tab activo de FormularioDAtosMultiTab.
 * v.2.27  08/05/2023 En la ññamada a <FormularioGrid, pasamos la  propiedad llamadoDesdeOtroFormulario
 * v.2.28  30/05/2023 En el metodo onSelectedRow, añadimos un tercer parámetro que es un callback, al que se llama al terminar.
 * v.2.29  13/07/2023 Añadida la propiedad desdeMovil: PropTypes.bool
 *                    Usada la propiedad desdeMovil en la llamada a <FormularioGrid
 *
 * v.2.30  31/07/2023 Añadida la propiedad onSelectedRowsChanged para podr transmitirla a FormularioGrid.
 *                    Modificado el método showEliminarElemento para añadir la opción de multiseleccion.
 *                    Modificado el método comprobarEliminarElemento para añadir la opción de multiseleccion.
 *                    Modificado el método eliminarElemento para añadir la opción de multiseleccion y uso de nueva gridConfig.urlDeleteMultiple.
 *
 * v.2.31 26/06/2024 Añadida la propiedad childrenFormulariogridPre y su suso en la llamada a <FormularioGrid
 * V.2.32 09/10/2024 Utilizacion en Render del Titulo con propiedad SoloTitulo en el caso simple
 */



import React from 'react'
import PropTypes from 'prop-types';

import ClienteRestful from "../network/ClienteRestful"
import FormularioGrid from './FormularioGrid'
import FormularioDatos from './FormularioDatos'
import {ACCION_NUEVO, ACCION_MODIFICAR, ACCION_CLONAR} from './TiposAcciones'
import FormularioDatosMultiTab from './FormularioDatosMultiTab'
import {BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_MODIFICAR, BOTONERA_ACCION_ELIMINAR, BOTONERA_ACCION_PDF, BOTONERA_ACCION_EXCEL, BOTONERA_ACCION_ELIMINARDESDEGRID} from "./FormularioBotonera";
import Dialogo from "../../blueprint/Dialogo";
import {Button, Icon} from "@blueprintjs/core";
import {connect} from "react-redux";
import Titulo from "./Titulo"
import {loadEntidad, loadServicioEntidad} from "../utils/EntidadJPAUtils";
import {
    estadoChangePaginaOrigen,
    estadoChangePagina
} from "../../../dental/redux/estado/actions";
import {setToString} from "../utils/SetUtils";
import {servicioRestful, servidor} from "../../../dental/Configuracion";

export const ELEMENTO_MODOCARGA_LISTA = 1;
export const ELEMENTO_MODOCARGA_BDD = 2;

class Formulario extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showGrid: props.showGrid ? props.showGrid : true,
            marcaTiempoGrid: props.marcaTiempoGrid ? props.marcaTiempoGrid : Date.now(),
            elemento: props.elemento,
            dialogoTexto: null,
            dialogoTipo: null,
            dialogoTitulo: null,
            dialogoOnClose: null,
            dialogoOnQuestion: null,
            paginaActual: 0,
            infoDatosInicial: null,
            valorBuscador: "",
            //filtroFijo: props.gridConfig ? props.gridConfig.filtroFijo : null,
            elementosSeleccionadosClaves: null,
        }
        if(props.elemento){
            this.state.accion= ACCION_MODIFICAR;
            this.state.showGrid= false;
            this.state.marcaTiempoGrid= Date.now();
        }

        //Si hay algún children preparado para usarlo en la TablaFlex, lo buscamos y lo metemos en el state
        console.log("props.children: ", props.children);
        if (props.children){
            let childTablaFlex= null;
            if (Array.isArray(props.children)) {
                props.children.some((child, index) => {
                    if (child.props.tablacelda) {
                        childTablaFlex = child;
                        return true;
                    }
                })
            }
            else {
                if (props.children.props.tablacelda)
                    childTablaFlex = props.children.props.tablacelda;
            }
            if (childTablaFlex)
                this.state.childTablaFlex= childTablaFlex;
        }

        this.formularioGrid= React.createRef();
        this.formularioDatosMultiTab= React.createRef();
        //console.log("FORMULARIO - Constructor");
        //console.log("props.showGrid: ", props.showGrid);
        //console.log("this.state.showGrid: ", this.state.showGrid);
        //console.log("props.elemento: ", props.elemento);
        //console.log("props: ", props);
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        //console.log("FORMULARIO: GETDERIVED");
        //console.log("nextProps: ", nextProps);

        if (nextProps.marcaTiempoGrid && nextProps.marcaTiempoGrid !== prevState.marcaTiempoGrid) {
            newState.marcaTiempoGrid = nextProps.marcaTiempoGrid;
        }

        /*
        if (nextProps.showGrid  && nextProps.showGrid !== prevState.showGrid) {
            console.log("nextProps.showGrid: ", nextProps.showGrid);
            newState.showGrid = nextProps.showGrid;
        }
        */

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    clonarElemento= (elementoOrigen) => {
        this.setState({accion: ACCION_CLONAR, showGrid : false,  marcaTiempoGrid: Date.now(), elementoOrigen: elementoOrigen});
    }


    onPageChanged= (paginaSelected) => {
        this.setState({paginaActual: paginaSelected});
    }


    onDatosBusquedaChanged= (datosBusqueda) => {
        this.setState({datosBusqueda: datosBusqueda});
    }

    onFiltroBusquedaChanged= (newFiltroBusqueda) => {
        this.setState({filtroBusqueda: newFiltroBusqueda});
    }


    onValorBuscadorCambiado= (valorBuscador) => {
        //console.log("onValorBuscadorCambiado: ", valorBuscador);
        this.setState({valorBuscador: valorBuscador});
    }

    onDatosGridCargados= (infoDatosInicial) => {
        const {onDatosCargados, onCalcularAviso} = this.props;
        //Cuando se cargan los datos, además de infoDAtos, si hay elementos tenemos que asignar el primero como elementoSeleccionado.
        //ESto es así por si le da al botón modificar sin haber pinchado en ninguno, para que el elemento que aparece marcado esté preparado.
        if (infoDatosInicial.datos.length > 0) {
            let elemento= infoDatosInicial.datos[0];
            this.setState({infoDatosInicial: infoDatosInicial}, this.elementoSeleccionado(elemento));
        }
        else
            this.setState( {infoDatosInicial: infoDatosInicial});

        onDatosCargados && onDatosCargados(infoDatosInicial);

        if (onCalcularAviso){
            let newGridAviso= onCalcularAviso(infoDatosInicial.datos);
            //console.log ("ONCALUCLARAVISO VUELTA");
            //console.log("newGrdiAviso: ", newGridAviso);
            this.setState({gridAviso: newGridAviso});
        }
    }

    elementoSeleccionado= (elemento, callback) => {
        const {onElementoSeleccionado, elementoConfig} = this.props;
        //console.log("FORMULARIO - ElementoSeleccionado");
        //console.log(elemento);
        //console.log("elementoConfig: ", elementoConfig);
        if (elemento) {
            if (elementoConfig && elementoConfig.modoCarga && elementoConfig.modoCarga == ELEMENTO_MODOCARGA_BDD) {
                let codigo = elemento.codigo;
                let nombreClase = elementoConfig.className;
                loadEntidad(nombreClase, codigo, (newElemento) => {
                    this.setState({elemento: newElemento});
                    onElementoSeleccionado && onElementoSeleccionado(newElemento);
                    callback && callback(elemento);
                });
            } else {
                console.log("NO MODO CARGA");
                this.setState({elemento: elemento});
                onElementoSeleccionado && onElementoSeleccionado(elemento);
                callback && callback(elemento);
            }
        }
    }

    onDobleClickCelda= (elemento) => {
        const {onElementoSeleccionado} = this.props;
        this.setState({accion: ACCION_MODIFICAR, showGrid : false,  marcaTiempoGrid: Date.now(), elemento: elemento});
        onElementoSeleccionado && onElementoSeleccionado(elemento);
    }



    onAccion= (accion, elemento) => {
        //console.log("Formulario ON ACCION");
        //console.log("accion: ", accion);
        //console.log("elemento: ", elemento);
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                //const {onNuevoElemento} = this.props;
                //if (onNuevoElemento)
                //    this.setState({accion: ACCION_NUEVO, showGrid : false,  marcaTiempoGrid: Date.now(), elemento: onNuevoElemento()});
                //else
                    this.setState({accion: ACCION_NUEVO, showGrid : false,  marcaTiempoGrid: Date.now()});
                break;
            case BOTONERA_ACCION_MODIFICAR:
                this.setState({accion: ACCION_MODIFICAR, showGrid : false,  marcaTiempoGrid: Date.now()});
                break;
            case BOTONERA_ACCION_ELIMINAR:
                this.showEliminarElemento();
                break;
            case BOTONERA_ACCION_ELIMINARDESDEGRID:
                this.eliminarDesdeGrid(elemento);
                break;
            case BOTONERA_ACCION_PDF:
                break;
            case BOTONERA_ACCION_EXCEL:
                break;
            default: break;
        }
    }

    // ----------------------------------------------------------------------------------------------
    // MULTISELECCION
    // ----------------------------------------------------------------------------------------------
    onElementosSeleccionadosCambiados= (newElementosSeleccionadosClaves) => {
        const {onSelectedRowsChanged} = this.props;

        this.setState({elementosSeleccionadosClaves: newElementosSeleccionadosClaves}, () => {
            onSelectedRowsChanged && onSelectedRowsChanged(newElementosSeleccionadosClaves);
        })
    }




    // ----------------------------------------------------------------------------------------------
    // ELIMINAR
    // ----------------------------------------------------------------------------------------------

    eliminarDesdeGrid= (elemento) => {
        //console.log("ELIMINAR DESDE GRID");
        //console.log("elemento: ", elemento);
        this.setState({elemento: elemento}, () => this.showEliminarElemento());
    }

    onCloseDialogEliminar= () =>{
        this.setState({dialogoTexto: null});
    }

    showEliminarElemento= () => {
        const {elemento, elementosSeleccionadosClaves} = this.state;

        console.log("formulario - SHOW ELIMINAR ELEMENTO");
        console.log("elemento: ", elemento);
        console.log("elementosSeleccionadosClaves: ", elementosSeleccionadosClaves);

        if (elemento) {
            let dialogoTexto = "¿Desea eliminar el elemento seleccionado? ";
            if (elementosSeleccionadosClaves && elementosSeleccionadosClaves.size > 1)
                dialogoTexto= "¿Desea eliminar los elementos seleccionados? ";
            if ((!elementosSeleccionadosClaves || elementosSeleccionadosClaves.size == 0 ) && elemento.nombre)
                dialogoTexto= "¿Desea eliminar " +  elemento.nombre + " ?";
            let dialogoTitulo = "Eliminación";
            let dialogoTipo = "PREGUNTA";
            this.setState({
                dialogoTitulo: dialogoTitulo, dialogoTexto: dialogoTexto,
                dialogoTipo: dialogoTipo,
                dialogoOnClose: this.onCloseDialogEliminar,
                dialogoOnQuestion: this.comprobarEliminarElemento //this.eliminarElemento
            });
        }
    }

    comprobarEliminarElemento= (aceptado) => {
        const {gridConfig, usuario} = this.props;
        const {elementosSeleccionadosClaves} = this.state;
        if (aceptado){
            if (gridConfig.eliminarComprobarServicio){

                const {elemento} = this.state;
                let parametros = {};
                if (!elementosSeleccionadosClaves || elementosSeleccionadosClaves.size == 0)
                    parametros.codigo = elemento.codigo;
                else
                    parametros.codigos = setToString(elementosSeleccionadosClaves);

                loadServicioEntidad(gridConfig.className, gridConfig.eliminarComprobarServicio, parametros,
                    (response) => {
                        console.log("response: ", response);
                        let resultado= response;
                        if (Boolean(resultado.exito) )
                            this.eliminarElemento(aceptado);
                        else {
                            let mensaje= "No es posible realizar toda la eliminación\r\n" + resultado.mensaje;
                            alert(mensaje);
                            this.setState({infoDatosInicial: null, dialogoTexto: null});
                        }


                    });
            }
            else{
                this.eliminarElemento(aceptado);
            }
        }
        else{
            this.setState({dialogoTexto: null});
        }
    }

    eliminarElemento= (aceptado) => {
        const {gridConfig, auth} = this.props;
        console.log("XXXXXXXXXX ELIMINAR ELEMENTO XXXXXXXXXx");
        if (aceptado) {
            const {elemento, elementosSeleccionadosClaves} = this.state;

            console.log("elemento: ", elemento);
            let codigo = elemento.codigo;
            let empresaCodigo = elemento.empresaCodigo ? elemento.empresaCodigo : -1;
            console.log("usuario: ", auth.usuario);
            console.log("gridConfig.url: ", gridConfig.url);
            console.log("gridConfig.urlDelete: ", gridConfig.urlDelete);
            console.log("gridConfig.className: ", gridConfig.className);
            console.log("codigo: ", codigo);
            console.log("elementosSeleccionadosClaves: ", elementosSeleccionadosClaves);
            if (elementosSeleccionadosClaves)
                console.log("elementosSeleccionadosClaves.size: ", elementosSeleccionadosClaves.size);
            console.log("empresaCodigo: ", empresaCodigo);
            console.log("usuario.codigo: ", auth.usuario.codigo);

            //a) Caso normal
            //let url = gridConfig.url + gridConfig.className + "/" + codigo + "/" + empresaCodigo + "/" + auth.usuario.codigo;
            //Nuevo Fusion
            let url = servidor + servicioRestful + gridConfig.className + "/" + codigo + "/" + empresaCodigo;

            //b) Caso múltiple
            if (elementosSeleccionadosClaves && elementosSeleccionadosClaves.size > 0 )
                url= gridConfig.url + "deletemultiple/" + gridConfig.className + "/" + setToString(elementosSeleccionadosClaves) + "/" + auth.usuario.codigo;

            //c) Caso url especial
            if (gridConfig.urlDelete && gridConfig.urlDelete != "") {
                if (!elementosSeleccionadosClaves || elementosSeleccionadosClaves.size == 0 ) {
                    url = gridConfig.urlDelete;
                    if (gridConfig.className)
                        url += gridConfig.className + "/";
                    url += codigo + "/" + empresaCodigo + "/" + auth.usuario.codigo;
                }
                else {
                    url = gridConfig.urlDeleteMultiple + setToString(elementosSeleccionadosClaves) + "/" + auth.usuario.codigo;
                }
            }
            console.log("url: ", url);


            const clienteRestful = new ClienteRestful().setUrl(url);
            clienteRestful.doDelete(response => {
                if (clienteRestful.exito && response) {
                    console.log("EXITO");
                    let resultado= response;
                    console.log("resultado: ", resultado);
                    this.setState({infoDatosInicial: null, dialogoTexto: null});
                    if (Boolean(resultado.exito)) {
                        this.refrescarDatosGrid();
                    }
                    else{
                        alert(resultado.mensaje);
                    }
                }
                else {
                    this.setState({infoDatosInicial: null, dialogoTexto: null});
                    alert("La eliminación no ha podido ser realizada. ");
                }

            });


        }
        else{
            this.setState({dialogoTexto: null});
        }
    }


    onClosedDatos= () => {
        const {llamadoDesdeOtroFormulario} = this.props;
        //console.log("ONCLOSEDDATOS");
        //console.log ("llamadoDesdeOtroFormulario: ", llamadoDesdeOtroFormulario);

        //Si tenemos prefijada una pagina de origen, volvemos a ella:
        const{paginaOrigen, tabOrigen, parametrosOrigen} = this.props.estado;
        if (!llamadoDesdeOtroFormulario && paginaOrigen){
            //Lo comentamos porque este proyecto no lo tiene.
            //console.log("Página de origen: ", paginaOrigen);
            //console.log("Tab de origen: ", tabOrigen);
            //console.log("Parámetros de origen: ", parametrosOrigen);
            //console.log("this.props.estado: ", this.props.estado);

            this.props.dispatch(estadoChangePaginaOrigen(null, null));
            this.props.dispatch(estadoChangePagina(paginaOrigen, tabOrigen, parametrosOrigen));
            return;
        }

        const {onElementoClosed} = this.props;
        //!!Hemos añadido marcaTiempoGrid: Date.now(), infoDatosInicial: null para forzar una carga.
        this.setState({showGrid: true, marcaTiempoGrid: Date.now(), infoDatosInicial: null});
        onElementoClosed && onElementoClosed();
    }

    onSavedDatos= (elementoInicial) => {
        const {accion} = this.state;
        const {onElementoAfterSave} = this.props;

        console.log("ONSAVEDDATOS");
        //console.log("onElementoAfterSave: ", onElementoAfterSave);

        //Ponemos infoDatosInicial para provocar un recargado de datos
        this.setState({showGrid: true, marcaTiempoGrid: Date.now(), infoDatosInicial: null});
        onElementoAfterSave && onElementoAfterSave(elementoInicial, accion);

        //Vemos la página de vuelta:
        //Si tenemos prefijada una pagina de origen, volvemos a ella:
        const{paginaOrigen, tabOrigen, parametrosOrigen} = this.props.estado;
        if (paginaOrigen){
            this.props.dispatch(estadoChangePaginaOrigen(null, null));
            this.props.dispatch(estadoChangePagina(paginaOrigen, tabOrigen, parametrosOrigen));
        }

    }


    renderTitulo= () => {
        const {showGrid, accion} = this.state;
        const {titulo, icon, llamadoDesdeOtroFormulario, enTab, usarTituloConDrawer} = this.props;

        /*
        console.log("RENDER TITULO");
        console.log("this.props: ", this.props);
        console.log("titulo", titulo);
        console.log("llamadoDesdeOtroFormulario: ", llamadoDesdeOtroFormulario);
        console.log("showGrid: ", showGrid);
        */

        let tituloReal= titulo;
        if (!showGrid){
            switch (accion){
                case ACCION_NUEVO: tituloReal=  titulo + " - NUEVO"; break;
                case ACCION_MODIFICAR: tituloReal=  titulo + " - MODIFICAR"; break;
                default: tituloReal= titulo; break;
            }
         }

        //console.log("tituloReal: ", tituloReal);

        let className= enTab === undefined || (enTab &&  Boolean(enTab)) ? "titulo" : "titulo2";
        if (!llamadoDesdeOtroFormulario) {
            if (showGrid){
                if (usarTituloConDrawer)
                    return <Titulo titulo={tituloReal} />
                else
                    return <Titulo soloTitulo={true} titulo={tituloReal} icon={icon}/>
                    //return <div className={className}> <Icon style={{margin:4}} iconSize={24} icon={icon}/>    {tituloReal}</div>;
            }
            else{
                if (usarTituloConDrawer)
                    return  <Titulo titulo={tituloReal}>
                        <Button icon="undo" style={{float: "right", marginTop: 2, marginBottom: 2}}
                                onClick={this.onClosedDatos}>Volver</Button>
                    </Titulo>
                else
                    return  <div className={className}>{tituloReal}
                        <Button icon="undo" style={{float: "right", marginTop: 2, marginBottom: 2}}
                                onClick={this.onClosedDatos}>Volver</Button>
                    </div>
            }
        }
        else{
            if (!showGrid)
                return  <div className={className}>{tituloReal}
                    <Button icon="undo" style={{float: "right", marginTop: 2, marginBottom: 2}}
                            onClick={this.onClosedDatos}>Volver</Button>
                </div>
        }

    }


    renderTitulo2= () => {
        const {showGrid, elemento, accion} = this.state;
        const {onCalcularSubtitulo, onClickBotonSubtitulo} = this.props;
        let titulo2= "";

        //console.log("renderTitulo2: ");
        //console.log("elemento: ", elemento);

        if (elemento){
            if (elemento.codigoid)
                titulo2 += elemento.codigoid;
            if (elemento.nombre) {
                if (titulo2 !== "")
                    titulo2 += " - ";
                titulo2 += elemento.nombre;
            }
        }

        //console.log("RENDER TITULO 2");
        //console.log("elemento: ", elemento);
        //console.log("titulo2: ", titulo2);

        if (onCalcularSubtitulo){
            titulo2= onCalcularSubtitulo(elemento);
        }

        if (!showGrid && accion === ACCION_MODIFICAR && titulo2 )
            if (onClickBotonSubtitulo)
                //return <div className="titulo2">{titulo2}<Button style={{margin: 2, color: 'white'}} minimal={true} small={true} icon="eye-open" onClick={(elemento) => onClickBotonSubtitulo(elemento)}/> </div>
                return <div className="titulo2">{titulo2}<Icon style={{marginLeft:10, cursor:"pointer"}} icon="eye-open" color="#FFFFFF" iconSize={24}
                                                               onClick={(mouseEvent) => onClickBotonSubtitulo(elemento)}/> </div>
            else
                return <div className="titulo2">{titulo2}</div>
    }

    refrescarDatosGrid= () => {
        if (this.formularioGrid && this.formularioGrid.current)
            this.formularioGrid.current.onRefreshData(0, true);
    }

    cambiarTabDatos= (tabId) =>{
        console.log("Formulario - cambiarTabDatos");
        console.log("this.formularioGrid: ", this.formularioGrid);
        console.log("this.formularioDatosMultiTab: ", this.formularioDatosMultiTab);
        if (this.formularioDatosMultiTab && this.formularioDatosMultiTab.current)
            this.formularioDatosMultiTab.current.onChangeTab(tabId);
    }
    render() {
        const {showGrid,  elemento, accion, dialogoTitulo, dialogoTexto, dialogoTipo, dialogoOnQuestion, dialogoOnClose,
            marcaTiempoGrid, paginaActual, elementoOrigen, datosBusqueda, infoDatosInicial, valorBuscador,
            filtroBusqueda,
            childTablaFlex} = this.state;
        const {
            id, titulo, gridConfig, elementoConfig, children, llamadoDesdeOtroFormulario, showBusqueda, onElementoBeforeSave, onClosedDatos, empresa,
            onModificarDatosGridCargados, onAntesCargarDatos, onNuevoElemento,
            dialogoDatosTitulo, dialogoDatosTexto, dialogoDatosTipo, onDialogoDatosCerrado,
            onElementoBeforeShow, usuario,
            onDatosModificados, onPermitirAceptar,
            modoMostrarDatos, mostrarConmutadorModoMostrarDatos,
            usarFiltros35,
            onAntesRenderDatosCampos,
            childrenFormulariogrid,
            onElementoAfterSave, onGuardarGridElementoModoCargaBDD,
            onSelectedRowsChanged,
            childrenFormulariogridPre,
        }= this.props;

        //console.log("<<<<<< FORMULARIO: RENDER ", id , "  >>>>>>>");
        //console.log("showGrid: ", showGrid);
        //console.log("valorBuscador: ", valorBuscador);
        //console.log("this.formularioGrid: ", this.formularioGrid);
        //console.log("elemento: ", elemento);
        //console.log("childrenFormulariogrid: ", childrenFormulariogrid);
        //console.log("estado: ", this.props.estado);
        //console.log("datosBusqueda: ", datosBusqueda);
        //console.log("usuario: ", usuario);

        return (

            <div style={{margin: 8, padding: 4}}>

                <Dialogo titulo={dialogoTitulo} mensaje={dialogoTexto} tipo={dialogoTipo}
                         onQuestion={dialogoOnQuestion}
                         onClose={dialogoOnClose}
                />

                {this.renderTitulo()}
                {this.renderTitulo2()}

                {showGrid &&
                    <FormularioGrid id={id}
                        ref={this.formularioGrid}
                        gridConfig={gridConfig}
                        elementoConfig={elementoConfig}
                        llamadoDesdeOtroFormulario={llamadoDesdeOtroFormulario}
                        onElementoSeleccionado={this.elementoSeleccionado}
                        onAccion={this.onAccion}
                        marcaTiempo={marcaTiempoGrid}
                        titulo={titulo}
                        showBusqueda={showBusqueda}
                        datosBusqueda={datosBusqueda}
                        paginaActual={paginaActual}
                        onPageChanged={this.onPageChanged}
                        onDatosBusquedaChanged={this.onDatosBusquedaChanged}
                        onFiltroBusquedaChanged={this.onFiltroBusquedaChanged}
                        filtroBusqueda={filtroBusqueda}
                        empresa= {empresa}
                        infoDatosInicial= {infoDatosInicial}
                        onDatosCargados={this.onDatosGridCargados}
                        onModificarDatosCargados={onModificarDatosGridCargados}
                        elementoSeleccionado={elemento}
                        valorBuscador={valorBuscador}
                        onValorBuscadorCambiado={this.onValorBuscadorCambiado}
                        onAntesCargarDatos= {onAntesCargarDatos}
                        //usuarioCodigo={this.props.usuarioCodigo}
                        onAntesGuardar= {onElementoBeforeSave}
                        onNuevoElemento= {onNuevoElemento}
                        usuario={usuario}
                        onDatosModificados= {onDatosModificados}
                        onSelectedRowsChanged= {this.onElementosSeleccionadosCambiados}

                        modoMostrarDatos={modoMostrarDatos}
                        mostrarConmutadorModoMostrarDatos={mostrarConmutadorModoMostrarDatos}
                        childTablaFlex={childTablaFlex} onDobleClickCelda={this.onDobleClickCelda}
                        usarFiltros35={usarFiltros35}
                        childrenFormulariogrid={childrenFormulariogrid}
                        childrenFormulariogridPre={ childrenFormulariogridPre}

                        //Nuevo:
                        onDespuesGuardarElemento={onElementoAfterSave}
                        onGuardarModoCargaBDD={onGuardarGridElementoModoCargaBDD}

                        desdeMovil= {this.props.estado.desdeMovil}
                    />
                }


                {!showGrid && !children && elementoConfig &&
                    <FormularioDatos elementoConfig={elementoConfig} elemento={elemento}
                                     accion={accion}
                                     onNuevoElemento={onNuevoElemento}
                                     //onNuevoElemento={this.onNuevoElemento}
                                     onCerrado={this.onClosedDatos}
                                     onGuardado={this.onSavedDatos}
                                     onAntesGuardar= {onElementoBeforeSave}
                                     onAntesMostrar={onElementoBeforeShow}
                                     dialogoTitulo={dialogoDatosTitulo}
                                     dialogoTexto={dialogoDatosTexto}
                                     dialogoTipo={dialogoDatosTipo}
                                     onDialogoCerrado={onDialogoDatosCerrado}
                                     onPermitirAceptar={onPermitirAceptar}
                                     usuario={usuario}
                                     onAntesRenderCampos={onAntesRenderDatosCampos}
                    />
                }

                {!showGrid && children && elementoConfig &&
                    <FormularioDatosMultiTab elementoConfig={elementoConfig} elemento={elemento}
                        ref={this.formularioDatosMultiTab}
                        accion={accion}
                        onCerrado={this.onClosedDatos}
                        onAntesGuardar= {onElementoBeforeSave}
                        onAntesMostrar={onElementoBeforeShow}
                        onGuardado={this.onSavedDatos}
                        elementoOrigen={elementoOrigen}
                        dialogoTitulo={dialogoDatosTitulo}
                        dialogoTexto={dialogoDatosTexto}
                        dialogoTipo={dialogoDatosTipo}
                        onDialogoCerrado={onDialogoDatosCerrado}
                        onPermitirAceptar={onPermitirAceptar}
                        usuario={usuario}
                    >
                        {children}
                    </FormularioDatosMultiTab>
                }

            </div>
        )
    }
}

//{!showGrid && elemento && elemento.nombre &&
//                 <div className="titulo2">{elemento.nombre}</div>
//                 }

Formulario.propTypes = {
    id: PropTypes.string,
    gridConfig: PropTypes.object.isRequired,
    marcaTiempoGrid: PropTypes.instanceOf(Date),
    elementoConfig: PropTypes.object,
    showBusqueda: PropTypes.bool,
    onElementoSeleccionado: PropTypes.func,
    onElementoBeforeSave: PropTypes.func,
    onElementoClosed: PropTypes.func,
    onElementoAfterSave: PropTypes.func,
    paginaActual: PropTypes.number,
    llamadoDesdeOtroFormulario: PropTypes.bool,
    onModificarDatosGridCargados: PropTypes.func,
    onDatosCargados: PropTypes.func,
    onNuevoElemento: PropTypes.func,
    elemento: PropTypes.object,
    onAntesCargarDatos: PropTypes.func,
    //usuarioCodigo: PropTypes.number,
    onElementoBeforeShow: PropTypes.func,
    onSelectedRowsChanged: PropTypes.func,

    dialogoDatosMensaje: PropTypes.string,
    dialogoDatosTipo: PropTypes.string,
    dialogoDatosTitulo: PropTypes.string,
    onDialogoDatosCerrado: PropTypes.func,

    showGrid: PropTypes.bool,

    usuario: PropTypes.object,
    empresa: PropTypes.object,

    onDatosModificados: PropTypes.func,
    onPermitirAceptar: PropTypes.func,
    onCalcularSubtitulo: PropTypes.func,
    onClickBotonSubtitulo: PropTypes.func,

    titulo: PropTypes.string,
    icon: PropTypes.string,
    usarTituloConDrawer: PropTypes.bool,

    mostrarConmutadorModoMostrarDatos: PropTypes.bool,
    modoMostrarDatos: PropTypes.number,
    usarFiltros35: PropTypes.bool,
    onCalcularAviso: PropTypes.func,
    onAntesRenderDatosCampos: PropTypes.func,

    childrenFormulariogrid: PropTypes.array,
    childrenFormulariogridPre: PropTypes.array,

    onGuardarGridElementoModoCargaBDD: PropTypes.func,

}

const mapStateToProps = function(state) {
    return {
        estado: state.estado,
        auth: state.auth,
    }
}

//Necesitamos hacer el connect para poder hacer Dispatchs
//HAcemos forwardRef para que los padres puedan usar <Formulario ref=...>
export default connect(mapStateToProps, null, null, { forwardRef: true })(Formulario);

